'use client';

import { V4ErrorShell } from '@/components/marketing/route-states/V4ErrorShell';

export default function ToolsMissedCallRoiError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <V4ErrorShell pillar="cyan" error={error} reset={reset} />;
}
